<template>
    <v-card class="mx-auto" flat max-width="900" color="transparent">
        <v-timeline :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item v-for="(artist, i) in artists"
                :key="artist.id"
                :right="i % 2 > 0"
                :left="i % 2 === 0">
                <jazz-artist :artist="artist" />
            </v-timeline-item>
        </v-timeline>
        <p class="caption">Photos des artistes &copy; 2015 Geetha Laune</p>
    </v-card>
</template>

<script>
import JazzArtist from './JazzArtist'

export default {
    name: 'jazz-artists',
    components: { JazzArtist },
    computed: {
        artists() {
            return this.$store.getters.artists
        }
    },

    mounted() {
        return this.$store.dispatch('artists')
    }
}
</script>
